<template>
    <div class="banner">
        <swiper @slideChange="onSlideChange" :centeredSlides="true" :pagination="{
            clickable: true
        }" :autoplay="{
            delay: 3000,
            disableOnInteraction: false
        }" :navigation="true" :modules="modules">
            <swiper-slide v-for="(slide, index) in slides" :key="index">
                <!-- <img :src="slide.image" :alt="slide.alt" class="img" /> -->
                <img v-lazy="banner" alt="">
            </swiper-slide>
        </swiper>
    </div>
</template>

<script setup>
import banner from "@/assets/images/index/banner.png"
import { ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
// 引入swiper样式，对应css 如果使用less或者css只需要把scss改为对应的即可
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
const modules = [Autoplay, Navigation, Pagination]
const slides = ref([
    { image: 'https://www.indubd.com/uploads/allimg/20240709/1-240F9152322228.png', alt: 'Slide 1' },

])
const activeIndex = ref(0)
const onSlideChange = (swiper) => {
    activeIndex.value = swiper.realIndex; // 更新当前激活的slide索引
    console.log(activeIndex.value)

};
</script>

<style scoped lang="less">
.banner {
    width: 100%;
    height: 61.25rem;
    /* background-color: pink; */
    z-index: 99;
    margin-top: -5.25rem;
}

img {
    width: 100%;
    height: 100%;

}

:deep(.swiper-button-prev:after, .swiper-rtl .swiper-button-next:after) {
    content: none;
}

:deep(.swiper-button-prev) {
    width: 5rem;
    height: 5rem;
    background-image: url(../assets/images/index/left.png);
    background-size: 5rem auto;
    margin-left: 3.75rem;

    &:hover {
        transform: scale(1.1);
        transition: all 0.5s;
    }
}

:deep(.swiper-button-next:after, .swiper-rtl .swiper-button-prev:after) {
    content: none;
}

:deep(.swiper-button-next) {
    width: 5rem;
    height: 5rem;
    background-image: url(../assets/images/index/right.png);
    background-size: 5rem auto;
    margin-right: 3.75rem;

    &:hover {
        transform: scale(1.1);
        transition: all 0.5s;
    }
}

:deep(.swiper-pagination-bullet) {
    width: 1.125rem;
    height: 1.125rem;
    background: rgb(77, 77, 78);
    opacity: 0.9;

}

:deep(.swiper-pagination-bullet-active) {
    width: 4.0625rem;
    height: 1.125rem;
    border-radius: 1.25rem;
    background: @xtxColor;

}

:deep(.swiper-pagination) {
    text-align: right;
    bottom: 2.625rem;
    ;
    left: -3.75rem;
}
</style>